import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 448 448",
  "content": "<symbol viewBox=\"0 0 448 448\" id=\"user\"><path d=\"M224 0c123.75 0 224 100.25 224 224 0 123-99.75 224-224 224C100 448 0 347.25 0 224 0 100.25 100.25 0 224 0zm154.75 337.75C402 305.75 416 266.5 416 224c0-105.75-86.25-192-192-192S32 118.25 32 224c0 42.5 14 81.75 37.25 113.75C78.25 293 100 256 145.75 256 166 275.75 193.5 288 224 288s58-12.25 78.25-32c45.75 0 67.5 37 76.5 81.75zM320 176c0-53-43-96-96-96s-96 43-96 96 43 96 96 96 96-43 96-96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/user.svg
// module id = fP5l
// module chunks = 1